import { render, staticRenderFns } from "./GestionNovedades.vue?vue&type=template&id=776f5d2b"
import script from "./GestionNovedades.vue?vue&type=script&lang=js"
export * from "./GestionNovedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports